import { DialogDismiss, DialogHeading } from "@ariakit/react";
import { atomic } from "../atomic.css";
import { Icon } from "../icon";

export function DialogHeader(props: { heading: string }) {
  return (
    <div
      className={atomic({
        display: "grid",
        gridTemplateColumns: "icon-fraction-icon",
        alignItems: "center",
      })}
    >
      <div />
      <DialogHeading
        className={atomic({
          textAlign: "center",
          fontFamily: "barlow-condensed",
          fontWeight: "semi-bold",
        })}
      >
        {props.heading}
      </DialogHeading>
      <DialogDismiss
        className={atomic({
          display: "block",
          padding: 8,
          stroke: "text-inverse",
          transition: "background-color",
          backgroundColor: {
            default: "text",
            hover: "text-secondary",
          },
        })}
      >
        <Icon name="cross" />
      </DialogDismiss>
    </div>
  );
}
